import { Attribute } from '.';

export class Source {
  id?: number;
  resource_uri?: string;
  title: string;
  default = false;
  services: Service[] = [];

  constructor(options?: any) {
    if (options) {
      this.title = options.verbose_name || options.url;
      Object.assign(this, { id: options.id, resource_uri: options.resource_uri });
    }
  }
}

export class Service {
  id: number;
  resource_uri: string;
  modelName: string;
  title: string;
  type: string;
  url: string = null;
  verbose: string;
  real_name: string;
  attributes: Attribute[] = [];
  geom_type: string;
  editable = false;
  time = false;

  constructor(options?: any) {
    if (options) {
      if (!options.title) {
        options.title = options.name;
      }
      Object.assign(this, options);
    }
  }
}
